<template>
    <AuthenticatedLayout>
      <div class="clients">
        <!-- Cabeçalho -->
        <header class="clients-header">
          <h2>Clientes</h2>          

            <el-button type="success" @click="handleModalFormClient()" icon="Plus">
                Cliente
            </el-button>
        </header>
  
        <!-- Tabela de Tarefas -->
        <el-table :data="clients" style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="Cliente" />
            <el-table-column prop="cnpj" label="CNPJ" />
            <el-table-column prop="category.name" label="Categoria" />
            <el-table-column prop="tasks" label="Qtde. Tarefas" />
            <el-table-column label="Status">
                <template #default="{ row }">
                <StatusGeneral :status="row.active" />
                </template>
            </el-table-column>           
          <el-table-column label="Ações">
            <template #default="scope">
                <el-button type="primary" @click="editClient(scope.row)" icon="Edit" plain />
                <el-button type="danger" @click="deleteClient(scope.row)" icon="Delete" plain />
            </template>
          </el-table-column>
        </el-table>     
        
        <el-dialog v-model="isModalVisible" :title="titleModal">
            <el-form label-position="top" :model="clientForm">

                <el-input v-model="clientForm.id" disabled hidden />                

                <el-form-item label="Nome do cliente">
                    <el-input v-model="clientForm.name" />
                </el-form-item>

                <el-form-item label="CNPJ">
                    <el-input v-model="clientForm.cnpj" v-mask="'##.###.###/####-##'" />
                </el-form-item>

                <el-form-item label="Categoria">
                    <el-select v-model="clientForm.category" placeholder="Selecione a Categoria">
                        <el-option
                            v-for="category in categories" 
                            :key="category.id"
                            :label="category.name" 
                            :value="category.id" 
                        />                        
                    </el-select>
                </el-form-item>

                <el-form-item label="Status">
                    <el-select v-model="clientForm.active" placeholder="Selecione o Status">
                        <el-option label="Ativo" value="1" />
                        <el-option label="Inativo" value="0" />
                    </el-select>
                </el-form-item>

            </el-form>
            <div>
                <el-button @click="isModalVisible = false">Cancelar</el-button>
                <el-button type="primary" @click="saveClient()">Salvar</el-button>
            </div>
        </el-dialog>

      </div>
    </AuthenticatedLayout>
  </template>
  
<script>
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout.vue";  
import { deleteClient, getAllClients, getCategories, storeClient, updateClient } from "@/services/clientService";
import { ElMessageBox, ElNotification } from 'element-plus';
import StatusGeneral from '@/components/StatusGeneral';

export default {
name: "ClientsView",
components: {
    AuthenticatedLayout,
    StatusGeneral    
},
data() {
    return {
        urlApi: process.env.VUE_APP_API_URL,
        clients: [],
        categories: [],
        clientForm: {
            id: null,
            name: '',
            cnpj: '',
            category: '',
            active: '1'
        },
        loading: false,
        isModalVisible: false,
        titleModal: 'Cadastrar Cliente',
        actionForm: 'create'
    };
},    
methods: {
    async fetchClients() {
        this.loading = true;
        try {
            const response = await getAllClients();
            this.clients = await response.data;
        } catch (error) {
            this.$message.error("Erro ao carregar clientes.");
        } finally {
            this.loading = false;
        }
    },

    async getCategories() {
        this.loading = true;
        try {
            const response = await getCategories();                           
            this.categories = response.data;

        } catch (error) {
            this.$message.error("Erro ao carregar categorias de tarefas.");
        } finally {
            this.loading = false;
        }
    },
    
    handleModalFormClient() {            
        this.isModalVisible = true;
        this.actionForm = 'create';
        this.titleModal = 'Cadastrar Cliente';
        this.resetForm();
    },

    editClient(client) {
        this.handleModalFormClient();

        this.clientForm = {
            id: client.id,
            name: client.name,
            cnpj: client.cnpj,
            category: client.category.id,
            active: String(client.active)
        }
        
        this.titleModal = 'Atualizar Cliente';
        this.actionForm = 'update';
    },

    async saveClient() {
        this.loading = true;
        this.errors = {};
        try {
            
            if (this.actionForm == 'create') {
                await storeClient(this.clientForm);

                ElNotification({
                    title: 'Atenção!',
                    message: 'Registro criado com sucesso.',
                    type: 'success'
                });
            }

            if (this.actionForm == 'update') {
                await updateClient(this.clientForm);
                ElNotification({
                    title: 'Atenção!',
                    message: 'Registro salvo com sucesso.',
                    type: 'success'
                });
            }

            this.isModalVisible = false;
            this.resetForm();
            this.fetchClients();

        } catch (error) {
            
            if (error.errors) {
                const errors = error.errors;
                const errorMessages = Object.values(errors)
                    .flat()
                    .join('\n');

                    ElNotification({
                        title: 'Erro de Validação',
                        message: errorMessages,
                        dangerouslyUseHTMLString: true,
                        type: 'error',
                    });
                    this.isModalVisible = true;
            } else {
                ElNotification({
                    title: 'Erro!',
                    message: 'Ocorreu um erro inesperado ao processar a solicitação.',
                    type: 'error',
                });
            }

        } finally {                        
            this.loading = false;
        }            
    },

    async deleteClient(client){

        let clientName = client.name;
        if (client.cnpj) {
            clientName += `(${client.cnpj})`
        }

        await ElMessageBox.confirm(
            `Deseja realmente deletar este registro: ${clientName}?`,
            'Warning',
            {
                confirmButtonText: 'Confirmar Exclusão',
                cancelButtonText: 'Cancelar',
                type: 'warning',
            }
        )
        .then(() => {
            this.loading = true;
            
            deleteClient(client.id);                                
            this.fetchClients();
            ElNotification({
                title: 'Atenção!',
                message: 'Registro deletado com sucesso.',
                type: 'success'
            });

        })
        .catch(() => {
            
        });

        this.fetchClients();
        this.loading = false;
    },

    resetForm() {
        this.clientForm = {
            id: null,
            name: '',
            cnpj: '',
            category: '',
            active: '1',
        }
    }
},
mounted() {
    this.fetchClients();
    this.getCategories();
},
};
</script>

<style scoped>
.clients-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.clients-header h2 {
    font-size: 24px;
    margin: 0;
}
.notification-icon {
    cursor: pointer;
}
</style>
